module.exports = __webpack_public_path__ + "img/white-hospital.f9a5d859.svg";